const NAMESPACE = "paymentHistoryActionRow";

const KEYS = {
    changeStatusButtonText: "changeStatusButtonText",
    viewHistoryButtonText: "viewHistoryButtonText"
};

const MESSAGES = {
    [KEYS.changeStatusButtonText]: {
        value: "Change Status",
        comment: "Text for the change status button"
    },
    [KEYS.viewHistoryButtonText]: {
        value: "View Payment History",
        comment: "Text for the view payment history button"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
